import { defineMessages } from 'react-intl';

import { CountryCodes } from 'src/common/enums';

/**
 * Why do we create different keys for different countries:
 * https://glints.slack.com/archives/CDD47CRH6/p1603446519490500?thread_ts=1603445986.488500&cid=CDD47CRH6
 */

const titleDefaultMessage = 'Browse Jobs In {country} by Category | Glints';

export const countrySpecificTitleMessages = defineMessages({
  [CountryCodes.SG]: {
    id: 'sg-jobs-by-career-page_meta_title',
    defaultMessage: titleDefaultMessage,
  },
  [CountryCodes.TW]: {
    id: 'tw-jobs-by-career-page_meta_title',
    defaultMessage: titleDefaultMessage,
  },
  [CountryCodes.ID]: {
    id: 'id-jobs-by-career-page_meta_title',
    defaultMessage: titleDefaultMessage,
  },
  [CountryCodes.VN]: {
    id: 'vn-jobs-by-career-page_meta_title',
    defaultMessage: titleDefaultMessage,
  },
  [CountryCodes.MY]: {
    id: 'my-jobs-by-career-page_meta_title',
    defaultMessage: titleDefaultMessage,
  },
});

const h1DefaultMessage = 'Browse Jobs In {country} by Category';

export const countrySpecificH1Messages = defineMessages({
  [CountryCodes.SG]: {
    id: 'sg-jobs-by-career-page_header',
    defaultMessage: h1DefaultMessage,
  },
  [CountryCodes.TW]: {
    id: 'tw-jobs-by-career-page_header',
    defaultMessage: h1DefaultMessage,
  },
  [CountryCodes.ID]: {
    id: 'id-jobs-by-career-page_header',
    defaultMessage: h1DefaultMessage,
  },
  [CountryCodes.VN]: {
    id: 'vn-jobs-by-career-page_header',
    defaultMessage: h1DefaultMessage,
  },
  [CountryCodes.MY]: {
    id: 'my-jobs-by-career-page_header',
    defaultMessage: h1DefaultMessage,
  },
});

const descriptionDefaultMessage =
  'Discover jobs opportunities from various category in {country} with Glints: Career Discovery without Limits';

export const countrySpecificDescriptionMessages = defineMessages({
  [CountryCodes.SG]: {
    id: 'sg-jobs-by-career-page_meta_description',
    defaultMessage: descriptionDefaultMessage,
  },
  [CountryCodes.TW]: {
    id: 'tw-jobs-by-career-page_meta_description',
    defaultMessage: descriptionDefaultMessage,
  },
  [CountryCodes.ID]: {
    id: 'id-jobs-by-career-page_meta_description',
    defaultMessage: descriptionDefaultMessage,
  },
  [CountryCodes.VN]: {
    id: 'vn-jobs-by-career-page_meta_description',
    defaultMessage: descriptionDefaultMessage,
  },
  [CountryCodes.MY]: {
    id: 'my-jobs-by-career-page_meta_description',
    defaultMessage: descriptionDefaultMessage,
  },
});
